import { useMemo } from "react";
function useLiveTakeoverState(parts) {
  return useMemo(() => {
    let active = false;
    let intercomConversationId;
    let teamId;
    let adminId;
    let adminName;
    let adminAvatarUrl;
    let startedAt;
    let explicitlyEnded = false;
    let canonicalActive;
    for (const part of parts) {
      if (part.type === "data-live-takeover-state") {
        const data = part.data;
        canonicalActive = !!(data == null ? void 0 : data.active);
        if (data == null ? void 0 : data.intercomConversationId) intercomConversationId = data.intercomConversationId;
        if (data == null ? void 0 : data.teamId) teamId = data.teamId;
        if (data == null ? void 0 : data.adminId) adminId = data.adminId;
        if (data == null ? void 0 : data.adminName) adminName = data.adminName;
        if (data == null ? void 0 : data.adminAvatarUrl) adminAvatarUrl = data.adminAvatarUrl;
        if (data == null ? void 0 : data.startedAt) startedAt = data.startedAt;
        if (!(data == null ? void 0 : data.active)) explicitlyEnded = true;
      } else if (part.type === "data-live-takeover-active") {
        const data = part.data;
        active = true;
        canonicalActive = true;
        explicitlyEnded = false;
        intercomConversationId = (data == null ? void 0 : data.intercomConversationId) ?? intercomConversationId;
      } else if (part.type === "data-live-takeover-started") {
        const data = part.data;
        active = true;
        canonicalActive = true;
        explicitlyEnded = false;
        intercomConversationId = (data == null ? void 0 : data.intercomConversationId) ?? intercomConversationId;
        teamId = (data == null ? void 0 : data.teamId) ?? teamId;
        startedAt = startedAt ?? (/* @__PURE__ */ new Date()).toISOString();
      } else if (part.type === "data-takeover-team-changed") {
        const data = part.data;
        teamId = (data == null ? void 0 : data.teamId) ?? teamId;
        adminId = (data == null ? void 0 : data.adminId) ?? adminId;
      } else if (part.type === "data-human-reply") {
        const data = part.data;
        adminName = (data == null ? void 0 : data.adminName) ?? adminName;
        adminAvatarUrl = (data == null ? void 0 : data.adminAvatarUrl) ?? adminAvatarUrl;
        if (!explicitlyEnded) active = true;
      } else if (part.type === "data-live-takeover-ended") {
        active = false;
        canonicalActive = false;
        explicitlyEnded = true;
      }
    }
    return {
      // Backend canonical state wins when known; otherwise fall back to fold.
      active: canonicalActive !== void 0 ? canonicalActive : active,
      intercomConversationId,
      teamId,
      adminId,
      adminName,
      adminAvatarUrl,
      startedAt
    };
  }, [parts]);
}
export {
  useLiveTakeoverState
};
//# sourceMappingURL=useLiveTakeoverState.js.map
